module.exports = __webpack_public_path__ + "img/image_16.3cf8007c.png";